import React, { useEffect } from 'react';
import { gridSpacing } from 'store/constant';
import { connect, useDispatch } from 'react-redux';
import { Typography, Grid, Paper } from '@mui/material';
import D2CDataView from 'components/d2c/D2CDataView';
// import IapAnalysisReport from 'components/iap/IapAnalysisReport';
import SearchBarD2c from 'components/Dashboard/SearchBarD2C';
// import CampaignPieIap from 'components/Dashboard/CampaignPieIap';
// import MediaCostIap from 'components/Dashboard/MediaCostIap';
import LoaderCustom from 'ui-component/LoaderCustom';
import { fetchD2CData, fetchD2CRequestData } from '../redux/d2c/d2cActions';
// import WidgetContainerIap from 'components/Dashboard/WidgetContainerIap';
import { SET_SIDE_MENU } from 'store/actions';
import D2CAnalysisReport from 'components/d2c/D2CAnalysisReport';
const D2CData = ({ fetchD2CData, advertiserList, isSkan, fetchD2CRequestData }) => {
  //   useEffect(() => {
  //     fetchD2CData()
  //   }, []);
  useEffect(() => {
    if (isSkan) {
      fetchD2CRequestData();
    } else {
      fetchD2CData();
    }
  }, [isSkan, fetchD2CRequestData, fetchD2CData]);
  const dispatch = useDispatch();
  useEffect(() => {
    localStorage.setItem('showSideMenu', true);
    dispatch({ type: SET_SIDE_MENU, showSideMenu: true });
  }, []);
  return (
    <>
      {' '}
      {advertiserList.length == 0 ? (
        <LoaderCustom />
      ) : (
        <>
          <Paper elevation spacing={gridSpacing} className="stickyBox">
            <SearchBarD2c />
          </Paper>
          <Grid container spacing={gridSpacing}>
            <Grid item xs={12}>
              <Grid container spacing={gridSpacing}>
                <Grid item lg={12} md={12} sm={6} xs={12}>
                  {/* <SearchBar/> */}
                </Grid>
              </Grid>
            </Grid>
            {/* <Grid item xs={12}>
              <Grid container spacing={gridSpacing}>
                <WidgetContainerIap />
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={gridSpacing}>
                <Grid item lg={8} md={8} sm={12} xs={12}>
                  <div style={{ height: '100%' }}>
                    <IapAnalysisReport />
                  </div>
                </Grid>
                <Grid item lg={4} md={4} sm={12} xs={12}>
                  <Grid container spacing={gridSpacing}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <CampaignPieIap />
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <MediaCostIap />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid> */}

            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={gridSpacing}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  {/* <D2CDataView /> */}
                  {isSkan ? <D2CAnalysisReport /> : <D2CDataView />}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    loading: state.d2cReducer.loading,
    d2cData: state.d2cReducer.d2cData,
    isSkan: state.campaignReducer.isSkan,
    advertiserList: state.advertiserReducer.advertiser_list,
    isDollar: state.campaignReducer.isDollar
  };
};
const mapDispatchToProps = {
  fetchD2CData: fetchD2CData,
  fetchD2CRequestData: fetchD2CRequestData
};
export default connect(mapStateToProps, mapDispatchToProps)(D2CData);
